import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Select } from "formsy-react-components";
import autoBind from "react-autobind";

class DivisionForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      canSubmit: false
    };

    autoBind(this);
  }

  enableButton() {
    this.setState({
      canSubmit: true
    });
  }

  disableButton() {
    this.setState({
      canSubmit: false
    });
  }

  submit(model) {
    this.props.onSave(model);
    this.refs.form.reset();
  }

  resetForm() {
    this.refs.form.reset();
  }

  render() {
    return (
      <Formsy
        ref="form"
        className="vertical form"
        onValidSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Col md={6}>
          <Input
            formNoValidate
            required
            name="description"
            label="Description"
            placeholder="Description"
            value={this.props.division.description || ""}
          />
        </Col>
        <Col md={6}>
          <Input
            formNoValidate
            required
            name="code"
            label="Code"
            placeholder="Code"
            value={this.props.division.code || ""}
          />
        </Col>
        <Col md={12}>
          <Link
            style={
              this.props.division.id != 0
                ? { display: "inline" }
                : { display: "none" }
            }
            className="btn btn-danger"
            to="/app/settings/divisions"
          >
            Cancel
          </Link>
          <button
            className="btn btn-warning"
            type="button"
            onClick={this.resetForm}
          >
            Reset
          </button>
          <input
            className="btn btn-success"
            type="submit"
            disabled={!this.state.canSubmit}
            value={this.props.saving ? "Saving... " : "Save"}
          />
        </Col>
      </Formsy>
    );
  }
}

DivisionForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  division: PropTypes.object.isRequired
};

export default DivisionForm;
